import EnfDashboardHomePage from "../components/archive/enforcements/EnfDashboardHomePage";
import EpaHealthStatsPage from "../components/archive/epaHealthStats/EpaHealthStatsPage";
import IpsDeficiencies from "../components/archive/ips/IpsDeficiencies";
import IpsDeficiencyAdminPage from "../components/archive/ips/IpsDeficiencyAdminPage";
import IpsDeficiencyGroupAdmin from "../components/archive/ips/ipsDeficiencyGroupAdmin";
import IpsViolationAdminPage from "../components/archive/ips/IpsViolationAdminPage";
import IpsIndexPage from "../components/archive/ips/IpsIndexPage";
import SecureModuleIndex from "../components/secure/SecureModuleIndex";
import StateWideReportsIndex from "../components/archive/StateWideReportsIndex";
import UnderConstructionCard from "../components/reuseableComponents/UnderConstructionCard";
import WsStatsPage from "../components/archive/waterSystemStatistics/WsStatsPage";

export const archiveRoutes = [
  {
    path: "/archive/enforcements-dashboard",
    component: EnfDashboardHomePage
  },
  {
    path: "/archive/epa-health-stats",
    component: EpaHealthStatsPage
  },
  {
    path: "/archive/ips/ips-deficiencies",
    component: IpsDeficiencies
  },
  {
    path: "/archive/ips/ips-index",
    component: IpsIndexPage
  },
  {
    path: "/archive/ips/ips-deficiencies-admin",
    component: IpsDeficiencyAdminPage
  },
  {
    path: "/archive/ips/ips-deficiency-group-admin",
    component: IpsDeficiencyGroupAdmin
  },
  {
    path: "/archive/ips/ips-violations-admin",
    component: IpsViolationAdminPage
  },
  {
    path: "/archive/state-wide-reports-index",
    component: StateWideReportsIndex
  },
  {
    path: "/archive/enforcements/selected-def-report",
    component: UnderConstructionCard
  },
  {
    path: "/archive/enforcements/worst-25-reports",
    component: UnderConstructionCard
  },
  {
    path: "/archive/under-construction",
    component: UnderConstructionCard
  },
  {
    path: "/archive/water-system-statistics",
    component: WsStatsPage
  },
  {
    path: "/secure/module-index",
    component: SecureModuleIndex
  }
];
